import { useRef, useState } from "react";
import { getYouTubeVideoId } from "../exports/functions";
import useMobile from "../hooks/useMobile";
import useTab from "../hooks/useTab";

const VideoOne = (props) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const { highlightsData } = props;
  const videoRef = useRef(null);
  const mobile = useMobile();
  const tab = useTab();
  let videoId = null;
  const videoUrl = highlightsData?.video_link;
  if (videoUrl) videoId = getYouTubeVideoId(videoUrl);

  const thumbnailSrc =
    highlightsData[0]?.thumbnail &&
    `${process.env.REACT_APP_cmsUrl}${highlightsData[0]?.thumbnail[0]?.media?.url}`;
  const videoSrc =
    highlightsData[0]?.video[0]?.media?.url &&
    `${process.env.REACT_APP_cmsUrl}${highlightsData[0]?.video[0]?.media?.url}`;

  return (
    <section className="video py-120">
      <div className="container">
        <div className="section-heading text-center" id="highlights">
          <div className="flex-align d-inline-flex gap-8 mb-16">
            <span className="text-main-600 text-2xl d-flex">
              <i className="ph-bold ph-book-open" />
            </span>
            <h5 className="text-main-600 mb-0">{highlightsData[0]?.snippet}</h5>
          </div>
          <h2 className="mb-24 wow bounceIn">{highlightsData[0]?.title}</h2>
          <p className="wow bounceInDown">{highlightsData[0]?.description}</p>
        </div>
      </div>

      <div className="video-img position-relative">
        <div className="container wow bounceIn">
          {!highlightsData?.[0]?.video_link &&
          highlightsData?.[0]?.thumbnail &&
          !isPlaying ? (
            <>
              <img
                src={thumbnailSrc}
                className="rounded-12 cover-img"
                alt=""
                // style={{
                //   height: highlightsData?.[0]?.attributes?.Thumbnail?.data
                //     ?.attributes?.url
                //     ? !mobile && !tab
                //       ? "120dvh"
                //       : "50dvh"
                //     : "default",
                // }}
              />
              {!isPlaying && (
                <span
                  onClick={() => {
                    setIsPlaying(true);
                    if (videoRef.current) {
                      videoRef.current.load();
                      videoRef.current.play();
                    }
                  }}
                  className="play-button position-absolute start-50 top-50 translate-middle z-1 w-72 h-72 flex-center bg-main-two-600 text-white rounded-circle text-2xl"
                  style={{ cursor: "pointer" }}
                >
                  <i className="ph-fill ph-play" />
                </span>
              )}
            </>
          ) : (
            <>
              {highlightsData[0]?.video ? (
                <div className="position-relative">
                  <video
                    ref={videoRef}
                    controls={isPlaying ? true : false}
                    // autoPlay
                    style={{
                      width: "100%",
                      display: "block",
                      backgroundColor: "black",
                    }}
                    // className="rounded-12"
                    preload="metadata"
                    onEnded={() => setIsPlaying(false)}
                  >
                    <source
                      src={isPlaying ? `${videoSrc}` : `${videoSrc}#t=0.6`}
                      type="video/mp4"
                    />
                  </video>

                  {!isPlaying && (
                    <span
                      onClick={() => {
                        setIsPlaying(true);
                        if (videoRef.current) {
                          videoRef.current.load();
                          videoRef.current.play();
                        }
                      }}
                      className="play-button position-absolute start-50 top-50 translate-middle z-1 w-72 h-72 flex-center bg-main-two-600 text-white rounded-circle text-2xl"
                      style={{ cursor: "pointer" }}
                    >
                      <i className="ph-fill ph-play" />
                    </span>
                  )}
                </div>
              ) : null}

              {/* <button
                onClick={() => setIsPlaying(false)}
                className="modal-x"
                style={{ position: "absolute", right: "10px", top: "10px" }}
              >
                <i className="ph-bold ph-x" />
              </button> */}
            </>
          )}

          {!highlightsData[0]?.video && videoId ? (
            <iframe
              width="100%"
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{ height: !mobile && !tab ? "100dvh" : "50dvh" }}
              className="rounded-12"
            ></iframe>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default VideoOne;

// import { useState } from "react";
// import { getYouTubeVideoId } from "../exports/functions";
// import useMobile from "../hooks/useMobile";
// import useTab from "../hooks/useTab";

// const VideoOne = (props) => {
//   const [isPlaying, setIsPlaying] = useState(false);
//   const { highlightsData } = props;
//   let videoId = null;

//   if (highlightsData && highlightsData[0]) {
//     const videoUrl = highlightsData[0].attributes?.Video_Link;
//     videoId = getYouTubeVideoId(videoUrl);
//   }
//   const mobile = useMobile();
//   const tab = useTab();

//   const videoUrl =
//     highlightsData[0]?.attributes?.Video?.data?.attributes?.url
//       ? `${process.env.REACT_APP_strapiUrl}${highlightsData[0].attributes.Video.data.attributes.url}`
//       : null;

//   return (
//     <section className="video py-120" id="highlights">
//       <div className="container">
//         <div className="section-heading text-center">
//           <div className="flex-align d-inline-flex gap-8 mb-16">
//             <span className="text-main-600 text-2xl d-flex">
//               <i className="ph-bold ph-book-open" />
//             </span>
//             <h5 className="text-main-600 mb-0">
//               {highlightsData[0]?.attributes?.Snippet}
//             </h5>
//           </div>
//           <h2 className="mb-24 wow bounceIn">
//             {highlightsData[0]?.attributes?.Title}
//           </h2>
//           <p className="wow bounceInDown">
//             {highlightsData[0]?.attributes?.Description}
//           </p>
//         </div>
//       </div>

//       <div className="video-img position-relative half-bg">
//         <div className="container wow bounceIn" style={{ position: "relative" }}>
//           {videoUrl ? (
//             <>
//               {!isPlaying ? (
//                 <>
//                   {/* Looping muted preview video */}
//                   <video
//                     className="rounded-12 cover-img"
//                     style={{
//                       height: !mobile && !tab ? "120dvh" : "100%",
//                       objectFit: "cover",
//                       cursor: "pointer",
//                     }}
//                     src={videoUrl}
//                     autoPlay
//                     muted
//                     loop
//                     playsInline
//                     preload="metadata"
//                     onClick={() => setIsPlaying(true)}
//                   />
//                   {/* Play button overlay */}
//                   <span
//                     onClick={() => setIsPlaying(true)}
//                     className="play-button position-absolute start-50 top-50 translate-middle z-1 w-72 h-72 flex-center bg-main-two-600 text-white rounded-circle text-2xl"
//                     style={{ cursor: "pointer", pointerEvents: "auto" }}
//                   >
//                     <i className="ph-fill ph-play" />
//                   </span>
//                 </>
//               ) : (
//                 <>
//                   {/* Full video player */}
//                   <video
//                     className="rounded-12 cover-img"
//                     style={{
//                       height: !mobile && !tab ? "120dvh" : "100%",
//                       objectFit: "contain",
//                       cursor: "default",
//                     }}
//                     src={videoUrl}
//                     controls
//                     autoPlay
//                     playsInline
//                   />
//                 </>
//               )}
//             </>
//           ) : (
//             <>
//               {/* If no direct video, fallback to YouTube thumbnail */}
//               {!isPlaying ? (
//                 <>
//                   <img
//                     src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
//                     className="rounded-12 cover-img"
//                     alt="Video thumbnail"
//                     style={{
//                       height: !mobile && !tab ? "120dvh" : "100%",
//                       cursor: "pointer",
//                       objectFit: "cover",
//                     }}
//                     onClick={() => setIsPlaying(true)}
//                   />
//                   <span
//                     onClick={() => setIsPlaying(true)}
//                     className="play-button position-absolute start-50 top-50 translate-middle z-1 w-72 h-72 flex-center bg-main-two-600 text-white rounded-circle text-2xl"
//                     style={{ cursor: "pointer", pointerEvents: "auto" }}
//                   >
//                     <i className="ph-fill ph-play" />
//                   </span>
//                 </>
//               ) : (
//                 <>
//                   {/* Replace with embedded YouTube iframe player */}
//                   <div
//                     style={{
//                       position: "relative",
//                       paddingBottom: "56.25%", // 16:9 aspect ratio
//                       paddingTop: 25,
//                       height: 0,
//                     }}
//                   >
//                     <iframe
//                       title="YouTube video player"
//                       style={{
//                         position: "absolute",
//                         top: 0,
//                         left: 0,
//                         width: "100%",
//                         height: "100%",
//                         borderRadius: "12px",
//                       }}
//                       src={`https://www.youtube.com/embed/${videoId}?autoplay=1&controls=1`}
//                       frameBorder="0"
//                       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                       allowFullScreen
//                     />
//                   </div>
//                 </>
//               )}
//             </>
//           )}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default VideoOne;
